import { requestGet, requestPut, requestPost, requestDelete } from '../utils/request';
import { Activity, ActivityComment, EnhancedScoutingPinPayload } from '../types/Activity';

export const ROOT_URL = '';
export const BASE_URL = '/api/tenderfoot/v2/activities';
export const BASE_URL_V3 = '/api/tenderfoot/v3/activities';
export const CATEGORY_BASE_URL = '/api/tenderfoot/v3/categoryAttributes';

export function requestActivities(field) {
  // We can send one field, a list of fields or not fields at all
  const fields = Array.isArray(field) ? field.join(',') : [field];

  return requestGet(`${BASE_URL_V3}?fields=${fields}&includeFieldNotes=true`, {
    rootUrl: ROOT_URL,
  });
}

export function sendComment(activityId: string, note: string): Promise<ActivityComment> {
  const url = `${BASE_URL}/${activityId}/comments`;
  return requestPost(url, { data: { note }, rootUrl: ROOT_URL });
}

export function removeComment(activityId: string, commentId: string): Promise<void> {
  const url = `${BASE_URL}/${activityId}/comments/${commentId}`;
  return requestDelete(url, { rootUrl: ROOT_URL });
}

export function requestActivity(activityId: string): Promise<Activity> {
  return requestGet(`${BASE_URL}/${activityId}`);
}

export function sendActivity(activity: EnhancedScoutingPinPayload) {
  return requestPost(`${BASE_URL_V3}`, { data: (activity as unknown) as Record<string, string>, rootUrl: ROOT_URL });
}

export function updateActivity(activity: EnhancedScoutingPinPayload) {
  return requestPut(
    `${BASE_URL_V3}/${activity.id}`,
    { data: (activity as unknown) as Record<string, string>, rootUrl: ROOT_URL }
  );
}

export function requestCategory(): Promise<unknown> {
  return requestGet(CATEGORY_BASE_URL, { rootUrl: ROOT_URL });
}
